import { AppConstants } from "./APIConstants";
import AuthComponent from "./../components/login/component/auth-provider";
import SessionStorageService from "./services/session-storage-service";
import axios from "axios";
import fileDownload from 'js-file-download';

export default class RestEndPoint {
    /** Common method for calling end points
     * @param  {String} url is the API url to which end point calls
     * @param  {String} type type of request wether it is GET, PUT or POST etc
     * @param  {String} functionKey key of the function app
     * @param  {Object} data is request payload and required for POST type
     * @param  {Object} headers required for http call eg: {'Content-type':'application/JSON'}
     * @return {} promise
     */ //'Access-Control-Allow-Origin':'*'
    static async call(url, type, data, headers) {
        const token = await this.getToken();
        return axios({
            url: url,
            method: type || "GET",
            params: data ? data : {},
            headers: headers || { Authorization: "Bearer " + token },
        });
    }

    /**
     * Post API request
     * @param  {} url
     * @param  {} type
     * @param  {} data
     * @param  {} headers
     * @return {} promise
     */
    static async post(url, type, data, headers) {
        const token = await this.getToken();
        Object.assign(data, headers);
        return axios({
            url: url,
            method: type || "POST",
            data: data ? JSON.stringify(data) : {},
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: "Bearer " + token,
            },
        });
    }

    static async callAzureFunction(url, type, functionKey, data, headers) {
        const token = await this.getToken();
        if (type != "GET") {
            Object.assign(data, headers);
        }
        return axios({
            url: url,
            method: type || "POST",
            data: data ? JSON.stringify(data) : {},
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "x-functions-key": functionKey,
                Authorization: "Bearer " + token,
            },
        });
    }
    static async callAzureFunctionPostFile(url, type, functionKey, data) {
        const token = await this.getToken();

        return axios({
            url: url,
            method: type || 'POST',
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
                'x-functions-key': functionKey,
                Authorization: 'Bearer ' + token
            }
        });
    };

    static async exportDocument(url, data) {
        const token = await this.getToken();
        return axios({
            url: url,
            method: "GET",
            params: data ? data : {},
            responseType: "blob",
            headers: { Authorization: "Bearer " + token },
        });
    }

    static async lealDetectionDownload(url, type, functionKey, data) {
        const token = await this.getToken();
        return axios({
            url: url,
            method: 'POST',
            data: data ? data : {},
            responseType: "blob",
            headers: { Authorization: "Bearer " + token, 'x-functions-key': functionKey },
        })
            .then((response) => {
                /* 
                * fileDownload - It is plugin, used for download file
                */
                let name = typeof data.fileName == 'undefined' ? 'Leak-Detection.xlsx' : data.fileName;
                fileDownload(response.data, name);
            })
    }

    /**
     * Post API request
     * @param  {} url
     * @param  {} type
     * @param  {} data
     * @param  {} headers
     * @return {} promise
     */
    static async postWithoutToken(url, type, data, headers) {
        Object.assign(data, headers);
        return axios({
            url: url,
            method: type || "POST",
            data: data ? JSON.stringify(data) : {},
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        });
    }

    /**
     * Method to get current logged in user name
     */
    static getCurrentUserName() {
        if (this.FetchUserName() != null) {
            return this.FetchUserName();
        } else {
            return "Guest";
        }
    }

    /**
     * Method to get current logged in user name
     */
    static getCurrentUserEmail() {
        if (this.FetchUserEmail() != null) {
            return this.FetchUserEmail();
        } else {
            return "Guest";
        }
    }

    /**
     * Method to get current logged in user roles
     */
    static getCurrentUserRoles() {
        if (this.FetchUserRoles() != null) {
            return this.FetchUserRoles();
        } else {
            return null;
        }
    }

    static FetchUserEmail() {
        if (sessionStorage.getItem("AUTH_TOKEN")) {
            var token = sessionStorage.getItem("AUTH_TOKEN");
            try {
                return JSON.parse(token).userName;
            } catch (e) {
                return null;
            }
        }
    }

    static FetchUserName() {
        if (sessionStorage.getItem("AUTH_TOKEN")) {
            //get token
            var token = sessionStorage.getItem("AUTH_TOKEN");
            try {
                return JSON.parse(token).displayName;
            } catch (e) {
                return null;
            }
        }
    }

    static FetchUserRoles() {
        if (sessionStorage.getItem("AUTH_TOKEN")) {
            var token = sessionStorage.getItem("AUTH_TOKEN");
            try {
                return JSON.parse(token).roles;
            } catch (e) {
                return [];
            }
        }
    }

    static async getToken() {
        let tokenValues = await AuthComponent.acquireTokenSilent();
        SessionStorageService.setAuthToken(tokenValues);
        return tokenValues.token;
    }
    static async getUserReadToken() {
        let tokenValues = await AuthComponent.acquireTokenUserScope();
        return tokenValues;
    }
    static async getUsers(userName) {
        const token = await this.getUserReadToken();
        //const tokenTest= await this.getToken();

        // startswith method expect value in single quotes
        return axios({
            url: `https://graph.microsoft.com/v1.0/users?$filter=startswith(displayName, '${userName}') or
        startswith(givenName, '${userName}') or startswith(surname, '${userName}') or 
        startswith(mail, '${userName}') or startswith(userPrincipalName, '${userName}')
        &$count=true&$top=6&$expand=manager($select=id,displayName,userPrincipalName,mail)`,
            method: "GET",
            headers: {
                ConsistencyLevel: "eventual",
                Authorization: "Bearer " + token,
            },
        })
    }

    static async getManager(userPrincipalName) {
        const token = await this.getUserReadToken();
        return axios({
            url:
                "https://graph.microsoft.com/v1.0/users/" +
                userPrincipalName +
                "/manager",
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
            },
        });
    }

    static FetchUserNameFromToken() {
        if (sessionStorage.getItem(AppConstants.AUTHTOKEN)) {
            let idToken = JSON.parse(sessionStorage.getItem(AppConstants.AUTHTOKEN));
            return idToken.userName;
        }
    }

    static FetchDisplayNameFromToken() {
        if (sessionStorage.getItem(AppConstants.AUTHTOKEN)) {
            let idToken = JSON.parse(sessionStorage.getItem(AppConstants.AUTHTOKEN));
            return idToken.displayName;
        }
    }

    static FetchRoleFromToken() {
        if (sessionStorage.getItem(AppConstants.AUTHTOKEN)) {
            let idToken = JSON.parse(sessionStorage.getItem(AppConstants.AUTHTOKEN));
            return idToken.roles;
        }
    }

    static checkCurrentUserHasRole(roleToCheck) {
        var found = null;
        var userRoles = this.FetchRoleFromToken();
        if (userRoles == null) {
            found = false;
        }
        else {
            found = userRoles.includes(roleToCheck);
        }
        return found;
    }
}
